import {
  View,
  Text,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  TextInput,
  TouchableOpacity,
  StyleSheet,
  ActivityIndicator,
} from "react-native";
import React, { useState, useEffect } from "react";
import { Image } from "@rneui/base";
import { auth } from "../firebase.js";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useStateContext } from "../lib/context";
import { Ionicons } from "@expo/vector-icons";

const LoginViajantes = ({ navigation }) => {
  const { currentUser, setCurrentUser, setIsViajante, setCorreoViajante } =
    useStateContext();
  const [btnLoading, setBtnLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const checkUser = auth.onAuthStateChanged((user) => {
      if (user) {
        setIsViajante(true);
        setCorreoViajante(user.email);
        setCurrentUser("need");
        navigation.navigate("SeleccionarCliente", user.email);
      }

      return checkUser;
    });
  }, []);

  useEffect(() => {
    if (email != "") {
      const cleanMail = email.toLowerCase();
      setEmail(cleanMail);
    }
  }, [email]);

  const inicioSesion = () => {
    setError("");
    if (!email || !password) {
      setError("Por favor complete todos los campos");
      return;
    }

    setBtnLoading(true);
    const auth = getAuth();
    const completeMail = email;
    signInWithEmailAndPassword(auth, completeMail, password)
      .then((userCredential) => {
        // Signed in - navigation handled by onAuthStateChanged
      })
      .catch((error) => {
        setBtnLoading(false);
        if (error.code === "auth/invalid-credential") {
          setError("Email o contraseña incorrectos");
        } else if (error.code === "auth/too-many-requests") {
          setError("Demasiados intentos. Intente más tarde");
        } else {
          setError("Error al iniciar sesión");
        }
      });
  };

  return (
    <KeyboardAvoidingView
      behavior={Platform.OS === "ios" ? "padding" : "height"}
      style={localStyles.container}
    >
      <ScrollView
        contentContainerStyle={localStyles.scrollContent}
        showsVerticalScrollIndicator={false}
      >
        {/* Header with Logos */}
        <View style={localStyles.logoContainer}>
          <Image
            source={require("../assets/placeholder.png")}
            style={localStyles.logoEro}
          />
          <Image
            source={require("../assets/drn-logo.png")}
            style={localStyles.logoDrn}
          />
        </View>

        {/* Welcome Card */}
        <View style={localStyles.welcomeCard}>
          <View style={localStyles.welcomeHeader}>
            <Ionicons name="people" size={32} color="#fff" />
            <Text style={localStyles.title}>Portal Viajantes</Text>
          </View>
          <Text style={localStyles.subtitle}>
            Acceso exclusivo para representantes de ventas
          </Text>
        </View>

        {/* Login Form */}
        <View style={localStyles.formCard}>
          <Text style={localStyles.formTitle}>Iniciar Sesión</Text>

          {/* Email Input */}
          <View style={localStyles.inputContainer}>
            <Text style={localStyles.inputLabel}>Correo Electrónico</Text>
            <View style={localStyles.inputWrapper}>
              <Ionicons
                name="mail-outline"
                size={20}
                color="#666"
                style={localStyles.inputIcon}
              />
              <TextInput
                placeholder="correo@ejemplo.com"
                value={email}
                onChangeText={setEmail}
                style={localStyles.input}
                placeholderTextColor="#999"
                autoCapitalize="none"
                keyboardType="email-address"
              />
            </View>
          </View>

          {/* Password Input */}
          <View style={localStyles.inputContainer}>
            <Text style={localStyles.inputLabel}>Contraseña</Text>
            <View style={localStyles.inputWrapper}>
              <Ionicons
                name="lock-closed-outline"
                size={20}
                color="#666"
                style={localStyles.inputIcon}
              />
              <TextInput
                placeholder="Ingrese su contraseña"
                value={password}
                onChangeText={setPassword}
                style={localStyles.input}
                placeholderTextColor="#999"
                secureTextEntry={!showPassword}
              />
              <TouchableOpacity
                onPress={() => setShowPassword(!showPassword)}
                style={localStyles.eyeIcon}
              >
                <Ionicons
                  name={showPassword ? "eye-outline" : "eye-off-outline"}
                  size={20}
                  color="#666"
                />
              </TouchableOpacity>
            </View>
          </View>

          {/* Error Message */}
          {error ? (
            <View style={localStyles.errorContainer}>
              <Ionicons name="alert-circle" size={16} color="#ff4444" />
              <Text style={localStyles.errorText}>{error}</Text>
            </View>
          ) : null}

          {/* Login Button */}
          <TouchableOpacity
            style={[
              localStyles.loginButton,
              btnLoading && localStyles.loginButtonDisabled,
            ]}
            onPress={inicioSesion}
            disabled={btnLoading}
          >
            {btnLoading ? (
              <ActivityIndicator color="#fff" />
            ) : (
              <>
                <Text style={localStyles.loginButtonText}>Iniciar Sesión</Text>
                <Ionicons name="arrow-forward" size={20} color="#fff" />
              </>
            )}
          </TouchableOpacity>

          {/* Vendor Login Button */}
          <TouchableOpacity
            style={localStyles.vendorButton}
            onPress={() => navigation.navigate("Login")}
          >
            <Ionicons name="business-outline" size={20} color="#2a2a8e" />
            <Text style={localStyles.vendorButtonText}>
              Inicio de Sesión Vendedor
            </Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
};

const localStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#F4F6FD",
  },
  scrollContent: {
    flexGrow: 1,
    padding: 20,
    justifyContent: "center",
  },
  logoContainer: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 30,
    gap: 20,
  },
  logoEro: {
    width: 120,
    height: 120,
    resizeMode: "contain",
  },
  logoDrn: {
    width: 100,
    height: 100,
    resizeMode: "contain",
  },
  welcomeCard: {
    backgroundColor: "#2a2a8e",
    borderRadius: 16,
    padding: 20,
    marginBottom: 20,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  welcomeHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 8,
    gap: 12,
  },
  title: {
    fontSize: 28,
    fontWeight: "bold",
    color: "#fff",
  },
  subtitle: {
    fontSize: 14,
    color: "rgba(255,255,255,0.9)",
    lineHeight: 20,
  },
  formCard: {
    backgroundColor: "#fff",
    borderRadius: 16,
    padding: 24,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  formTitle: {
    fontSize: 20,
    fontWeight: "600",
    color: "#2a2a8e",
    marginBottom: 20,
  },
  inputContainer: {
    marginBottom: 16,
  },
  inputLabel: {
    fontSize: 14,
    fontWeight: "600",
    color: "#333",
    marginBottom: 8,
  },
  inputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#F4F6FD",
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#E0E0E0",
    paddingHorizontal: 12,
  },
  inputIcon: {
    marginRight: 10,
  },
  input: {
    flex: 1,
    paddingVertical: 14,
    fontSize: 16,
    color: "#333",
  },
  eyeIcon: {
    padding: 4,
  },
  errorContainer: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#ffebee",
    padding: 12,
    borderRadius: 8,
    marginBottom: 16,
  },
  errorText: {
    color: "#ff4444",
    fontSize: 14,
    marginLeft: 8,
    flex: 1,
  },
  loginButton: {
    backgroundColor: "#2a2a8e",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 16,
    borderRadius: 12,
    marginTop: 8,
    shadowColor: "#2a2a8e",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 4,
  },
  loginButtonDisabled: {
    opacity: 0.6,
  },
  loginButtonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
    marginRight: 8,
  },
  vendorButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 14,
    borderRadius: 12,
    marginTop: 12,
    borderWidth: 2,
    borderColor: "#2a2a8e",
    backgroundColor: "transparent",
  },
  vendorButtonText: {
    color: "#2a2a8e",
    fontSize: 15,
    fontWeight: "600",
    marginLeft: 8,
  },
});

export default LoginViajantes;
